<!--tab-->
<template>
 <div class="data-card-tab">
        <template v-for="(item,index) in tabList">
          <div :id="name+index" :style="'font-size:' + tabFontSize + '!important'" :key="index" :class="['data-card-tab-item',{'data-card-tab-active':curIndex==index}]"
            @click="switchTab(index)" >{{item}}</div>
          <div class="data-card-tab-space" id="tab-space" :key="index+'space'" :style="'width:' + spaceWidth + 'px'"></div>
        </template>

        <div ref="line" class="data-card-tab-line"
          :style="'width:'+width+'px;transform:translateX('+left+'px);transition-duration: 0.3s;'"></div>
      </div>
</template>

<script>
    export default {
        components: {},
        props: {
            // 数据
            tabList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            name: {
                type: String,
                default: ''
            },
            indexKey: {
                type: String,
                default: ''
            },
            spaceWidth: {
                type: Number,
                default: 16
            },
            tabFontSize: {
                type: String,
                default: '12px'
            }

        },
        data () {
            return {
                curIndex: 0,
                width: 0,
                left: 0
            }
        },
        computed: {

        },
        methods: {
            switchTab (index) {
                this.curIndex = index
                let length = 0
                for (let i = 0; i < this.tabList.length; i++) {
                    let tabDiv = document.querySelector('#' + this.name + i)
                    console.log('document:', tabDiv);
                    console.log('index值变化:', index);
                    console.log('i值变化:', i);
                    if (i < index) {
                        console.log('这个dom的偏移量值:', document.querySelector('#tab-space').offsetWidth);
                        length += tabDiv.offsetWidth + (document.querySelector('#tab-space').offsetWidth > 0 ? document.querySelector('#tab-space').offsetWidth : 16)
                        console.log('length值变化:', length);
                    } else if (i === index) {
                        this.$nextTick(() => {
                            console.log('没执行？', tabDiv.offsetWidth);
                            this.width = tabDiv.offsetWidth
                        })
                    }
                }
                console.log('偏移距离：', length);
                this.left = length
                this.$emit('onSwitch', index, this.indexKey)
            }

        },
        mounted () {
            this.switchTab(0)
        }

    }
</script>

<style scoped lang="less">
.data-card-tab {
        display: flex;
        margin-top: 24px;
        position: relative;

        &-item {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
        }

        &-space {
          width: 16px;
        }

        &-active {
          color: rgba(54, 179, 116, 1);
          font-weight: 700;
        }

        &-line {
          position: absolute;
          bottom: -6px;
          left: 0;
          z-index: 1;
          width: 56px;
          height: 2px;
          background: rgba(54, 179, 116, 1);
        }
      }
</style>
